import { render, staticRenderFns } from "./Blackbook.vue?vue&type=template&id=28508e30&scoped=true&"
import script from "./Blackbook.vue?vue&type=script&lang=js&"
export * from "./Blackbook.vue?vue&type=script&lang=js&"
import style0 from "./Blackbook.vue?vue&type=style&index=0&id=28508e30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28508e30",
  null
  
)

export default component.exports